export default "__VITE_ASSET__B5D_$FYn__"